/* eslint-disable jsx-a11y/anchor-has-content */

import { Text } from '@audio-network/componentlibrary'
import { WarningLight } from '@audio-network/componentlibrary/icons'
import clsx from 'clsx'
import { Trans, useTranslation } from 'next-i18next'

import styles from './DownloadUnavailable.module.css'

const DownloadUnavailable: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
	className,
	...props
}): JSX.Element => {
	const { t } = useTranslation(['app'])

	return (
		<div
			data-testid="unavailable"
			className={clsx(styles.downloadUnavailableWarningMessage, className)}
			{...props}
		>
			<WarningLight />
			<Text variant="bodyS">
				<Trans components={{ a: <a href="/contact" /> }}>
					{t('download-unavailable')}
				</Trans>
			</Text>
		</div>
	)
}

export default DownloadUnavailable
